export function formatProviderUsageRelativeTime(iso: string): string {
  const targetMs = new Date(iso).getTime();
  if (Number.isNaN(targetMs)) return "unknown";

  const diffMinutes = Math.round((targetMs - Date.now()) / 60_000);
  const past = diffMinutes <= 0;
  const absMinutes = Math.abs(diffMinutes);

  if (absMinutes < 1) return past ? "just now" : "in under a minute";
  if (absMinutes < 60) return past ? `${absMinutes}m ago` : `in ${absMinutes}m`;

  const hours = Math.round(absMinutes / 60);
  if (hours < 48) return past ? `${hours}h ago` : `in ${hours}h`;

  const days = Math.round(hours / 24);
  return past ? `${days}d ago` : `in ${days}d`;
}
